import React from 'react';
import { WithIcon } from './WithIcon';

export const IconRead = WithIcon(
  'Read',
  '0 0 20 20',
  <>
    <path
      fillRule="evenodd"
      d="M15.6733 3.3334H4v1h11.6733v-1Zm0 4H4v1h11.6733v-1ZM4 11.3334h11.6733v1H4v-1Zm11.6733 4H4v1h11.6733v-1Z"
      clipRule="evenodd"
    />
    <mask
      id="mask0_71_402"
      width="12"
      height="14"
      x="4"
      y="3"
      maskUnits="userSpaceOnUse"
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M15.6733 3.3334H4v1h11.6733v-1Zm0 4H4v1h11.6733v-1ZM4 11.3334h11.6733v1H4v-1Zm11.6733 4H4v1h11.6733v-1Z"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#mask0_71_402)">
      <path fillRule="evenodd" d="M0 0h20v20H0V0Z" clipRule="evenodd" />
    </g>
  </>
);
